import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';
import { SwiperCitiesModule } from '../swiper-cities/swiper-cities.module';
import { MenuCitiesModule } from '../menu-cities/menu-cities.module';
import { MenuCustomerModule } from '../menu-customer/menu-customer.module';
import { FormsModule } from '@angular/forms';
import { MenuProducerModule } from '../menu-producer/menu-producer.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SwiperCitiesModule,
    MenuCitiesModule,
    MenuProducerModule,
    MenuCustomerModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [HeaderComponent]
})
export class HeaderModule { }
